/* src/app/component/login/login.component.css */
:host-context(app-login) {
  color: var(--text-color-900);
}
:host-context(app-login) .is__invalid-input {
  border-color: #e11d48;
}
:host-context(app-login) .is__invalid-error {
  color: #e11d48;
}
:host-context(app-login) .is__invalid-error {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
:host-context(app-login) .is__invalid-error {
  padding-top: 0.25rem;
}
:host-context(app-login) .is__invalid-error {
  font-size: 0.75rem;
  line-height: 1rem;
}
:host-context(app-login) .eye {
  height: 1rem;
  width: auto;
}
:host-context(app-login) button {
  background-color: var(--primary-color);
}
:host-context(app-login) button :hover {
  background-color: var(--secondary-color);
}
/*# sourceMappingURL=login.component.css.map */
